import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { Dependencies } from '@adornis/materialized-views/decorators/dependency.js';
import { calculateWorkingHoursForEingruppierung } from '../../../api/calculateWorkingHours.js';
import { AGArbeitszeit } from './AGArbeitszeit.js';
import { AGLohnGehaltszahlungen } from './AGLohngehaltszahlungen.js';
import { AGVertragsInfos } from './AGvertragsinfos.js';

/**
 * @entity AGEingruppierungSektion
 */
@Entity()
export abstract class AGEingruppierung extends AdornisEntity {
  static override _class = 'AGEingruppierung';

  constructor(doc: PartialEntityData<AGEingruppierung>) {
    super(doc);
  }

  @Field(type => AGVertragsInfos, { default: v => v ?? new AGVertragsInfos({}) })
  agVertragsInfos: Maybe<AGVertragsInfos>;

  @Field(type => AGLohnGehaltszahlungen, { default: v => v ?? new AGLohnGehaltszahlungen({}) })
  agLohnGehaltszahlungen: Maybe<AGLohnGehaltszahlungen>;

  @Field(type => AGArbeitszeit, { default: v => v ?? new AGArbeitszeit({}) })
  agArbeitszeit: Maybe<AGArbeitszeit>;

  @Dependencies({
    classes: () => [],
    ids: () => [],
  })
  @Field(type => Float, {
    resolve: function (this: AGEingruppierung) {
      return () => {
        const hours = calculateWorkingHoursForEingruppierung(this);

        return parseFloat(hours.toFixed(2));
      };
    },
  })
  paidWorkTime: Maybe<number>;

  @Dependencies({
    classes: () => [],
    ids: () => [],
  })
  @Field(type => Float, {
    resolve: function (this: AGEingruppierung) {
      return () => {
        const hours = calculateWorkingHoursForEingruppierung(this, true);

        return parseFloat(hours.toFixed(2));
      };
    },
  })
  totalWorkTime: Maybe<number>;
}

/**
 * @entity AGEingruppierung1
 */
@Entity()
export class AGEingruppierung1 extends AGEingruppierung {
  static override _class = 'AGEingruppierung1';
}

/**
 * @entity AGEingruppierung2
 */
@Entity()
export class AGEingruppierung2 extends AGEingruppierung {
  static override _class = 'AGEingruppierung2';
}
